<app-dialog-wrapper
    heading="request.requestDetail.demandFeedbackDialog.title"
    description="request.requestDetail.demandFeedbackDialog.description"
    confirmLabel="request.requestDetail.demandFeedbackDialog.emea.confirm"
    cancelLabel="request.requestDetail.demandFeedbackDialog.emea.cancel"
    width="650px"
    (confirmed)="confirm()"
    (cancelled)="close()"
>
    <form class="flex flex-col gap-4" [formGroup]="formGroup">
        <sh-editor
            formControlName="comment"
            [placeholder]="'request.requestDetail.demandFeedbackDialog.comment' | translate"
            class="w-full"
        ></sh-editor>
        <sh-file-input
            formControlName="attachments"
            [maxFileSizeMB]="500"
            [multiple]="true"
            class="w-full"
        ></sh-file-input>
    </form>
</app-dialog-wrapper>
